import { createTRPCProxyClient, httpBatchLink } from '@trpc/client';
import superjson from 'superjson';
import type { AppRouter } from "@lift-admin/common/apiTypes";
import apiClient from '@lift-admin/utils/apiClient';
import { authFirebase } from '@lift-admin/utils';

// Extract base URL without trailing slash
const baseURLRaw = apiClient.defaults.baseURL || 'http://localhost:4010';
// const baseURLRaw = 'http://localhost:4010';
const baseURL = baseURLRaw.endsWith('/') ? baseURLRaw.slice(0, -1) : baseURLRaw;

// Function to get a fresh Firebase auth token
const getAuthToken = async () => {
  const user = authFirebase.currentUser;
  if (user) {
    try {
      return await user.getIdToken();
    } catch (error) {
      console.warn('Error getting Firebase token, trying refresh:', error);
      try {
        return await user.getIdToken(true);
      } catch (refreshError) {
        console.error('Error refreshing Firebase token:', refreshError);
        return null;
      }
    }
  }
  return null;
};

// Listen for auth state changes and update Authorization header
authFirebase.onAuthStateChanged(async (user) => {
  if (user) {
    const idToken = await getAuthToken();
    if (idToken) {
      apiClient.defaults.headers.common['Authorization'] = `Bearer ${idToken}`;
    }
  } else {
    delete apiClient.defaults.headers.common['Authorization'];
  }
});

export const trpc = createTRPCProxyClient<AppRouter>({
  links: [
    httpBatchLink({
      url: `${baseURL}/report/v1`,
      // url: `${baseURL}/v1`,
      transformer: superjson,
      headers: async () => {
        const idToken = await getAuthToken();
        return {
          'Accept': '*/*',
          Authorization: idToken ? `Bearer ${idToken}` : '',
        };
      },
    }),
  ],
});
